import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { Container } from '../../layout'
import { breakpoints, useMediaQuery } from '../../../lib/hooks'

const LegalNotice = ({ lightMode = false }: { lightMode?: boolean }) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)

  const ContentLegalNotice = () => (
    <div className={clsx({ [s.lightMode]: lightMode }, s.legalNotice)}>
      <p>
        <FormattedMessage
          id='ui.LegalNotice.NabooCapitalAddress'
          defaultMessage='WOME STAY (NABOO) | Société par action simplifiée au capital de 32.026 € | Siège social : 15 rue Clapeyron,
        75008 Paris, France'
        />
      </p>
      <p>
        <FormattedMessage
          id='ui.LegalNotice.NabooRCS'
          defaultMessage='RCS PARIS 904 443 462 | TVA FR32 904 443 462 |WOME STAY est immatriculée sous le numéro IM075240016 au registre
        des opérateurs de voyages et de séjours auprès d’Atout France dont le siège social est situé au 200/216 rue
        Raymond Losserand, CS 60043, 75680 PARIS Cedex 14'
        />
      </p>
    </div>
  )
  return (
    <>
      {!isMobile ? (
        <ContentLegalNotice />
      ) : (
        <Container style={{ marginTop: 20, borderRadius: 20 }}>
          <ContentLegalNotice />
        </Container>
      )}
    </>
  )
}

export default LegalNotice
